// Generated by scripts/build-ui-icons.mjs.
export { Signpost as default } from "../ui/glyphs-7";
